import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HeadingSecondary from "../components/ HeadingSecondary";
import { formatBirthDate } from "../helper/helper";
import DotLoading from "../components/DotLoading";
import profileService from "../services/profile.service";

type ProfileForm = {
  email: string;
};

const SettingProfile: React.FC<any> = ({ history }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState<any>(null);

  useEffect(() => {
    if (successMessage !== null) {
      toast.success("ایمیل شما با موفقیت ثبت شد.", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        progress: undefined,
      });
    }
  }, [successMessage]);

  const {
    register,
    handleSubmit,
    setFocus,
    formState: { errors },
  } = useForm<ProfileForm>();

  const onSubmit = async (formData: ProfileForm) => {
    setIsLoading(true);
    try {
      // eslint-disable-next-line
      const { data } = await profileService.persistEmail(formData);
      localStorage.setItem("email", formData.email) as any;
      setSuccessMessage("ok");
      // console.log(data);
    } catch (error: any) {
      if (error.response) {
        // console.log(error.response.data);
        console.log(error.response.status);
        // console.log(error.response.headers);
      } else if (error.request) {
        console.log("The request was made but no response was received");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // console.log(watch());
  // console.log(errors);

  const [userLoginInfo, setUserLoginInfo] = useState({
    access_token: "",
    birthDate: "",
    expires_in: "",
    jti: "",
    mobileNumber: "",
    nationalId: "",
    refresh_token: "",
    scope: "",
    token_type: "",
    email: "",
  });

  // eslint-disable-next-line
  const email = useRef<HTMLInputElement>(null);
  useEffect(() => {
    // email.current!.focus();
    setFocus("email");
    (() => {
      try {
        let getUserLoginInfo = JSON.parse(
          localStorage.getItem("userLoginInfo") as any
        ) as any;
        let email = localStorage.getItem("email") as any;
        setUserLoginInfo({ ...getUserLoginInfo, email: email });
      } catch (e: any) {
        localStorage.removeItem("userLoginInfo");
        history.replace("/");
      }
    })();
    // eslint-disable-next-line
  }, [history]);

  return (
    <>
      <ToastContainer rtl />
      <div className="setting">
        <div className="u-margin-top-medium u-margin-bottom-small-2">
          <HeadingSecondary text="پروفایل" />
        </div>
        <div className="setting__profile">
          <form
            className="setting__profile__form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="setting__profile__form__row">
              <input
                type="text"
                className={`${errors.email && "input-error"}`}
                id="email"
                placeholder={userLoginInfo.email}
                {...register("email", {
                  required: true,
                  pattern: /^\S+@\S+$/i,
                })}
              />
              {errors.email && errors.email.type === "required" && (
                <p className="error-box__content">پر کردن ایمیل الزامی است .</p>
              )}
              {errors.email && errors.email.type === "pattern" && (
                <p className="error-box__content">فرمت ایمیل اشتباه است .</p>
              )}
              <label htmlFor="email">ایمیل</label>
            </div>
            <div className="setting__profile__form__row">
              <input
                type="text"
                id="nationalCode"
                value={userLoginInfo.nationalId}
                readOnly={true}
              />
              <label htmlFor="nationalCode">کد ملی</label>
            </div>
            <div className="setting__profile__form__row">
              <input
                type="text"
                id="birthDate"
                value={formatBirthDate(userLoginInfo.birthDate)}
                readOnly={true}
              />
              <label htmlFor="birthDate">تاریخ تولد</label>
            </div>
            <div className="setting__profile__form__row">
              <input
                type="text"
                id="phoneNumber"
                value={userLoginInfo.mobileNumber}
                readOnly={true}
              />
              <label htmlFor="phoneNumber">تلفن همراه</label>
            </div>

            <button
              className="btn btn--primary u-width-100 u-margin-top-medium-5 u-margin-bottom-big"
              type={`${isLoading ? "button" : "submit"}`}
              disabled={successMessage}
            >
              {!isLoading ? "ثبت" : <DotLoading />}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default SettingProfile;
